__turbopack_context__.v({
  "details": "run-details-module__n2AEXG__details",
  "facts": "run-details-module__n2AEXG__facts",
  "timeline": "run-details-module__n2AEXG__timeline",
});
